import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20red%20carpet%20event%20with%20dramatic%20spotlight%20and%20camera%20flashes%2C%20glamorous%20entertainment%20atmosphere%2C%20soft%20bokeh%20background%2C%20elegant%20abstract%20style%2C%20warm%20coral%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20luxurious%20event%20photography%20feel%2C%20no%20people%20visible%2C%20atmospheric%20scene&width=1600&height=600&seq=cta-bg-01&orientation=landscape"
        alt="今日看料 - 加入吃瓜一线"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="lg:max-w-xl">
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
              精彩不止
              <br />
              于此
            </h2>
            <Link
              to="/category/chigua-qianxian"
              className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-background-50 hover:bg-background-100 transition-colors group whitespace-nowrap cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-950">探索更多爆料</span>
              <div className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="lg:max-w-xs">
            <p className="text-background-50/85 text-sm md:text-base leading-relaxed">
              每天更新最新最热的吃瓜内容
              <br />
              网红爆料、娱乐圈八卦、PP料行情
              <br />
              一手掌握
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}